var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShipmentNotPossible = function SvgShipmentNotPossible(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#003A4F",
    d: "M6.75 4A.25.25 0 0 0 7 3.75V.5a.25.25 0 0 0-.25-.25H5.164c-.399 0-.781.158-1.064.439L1.219 3.573A.25.25 0 0 0 1.4 4zM15.068 9.563a.25.25 0 0 0 .182-.241V5.75A.25.25 0 0 0 15 5.5H.5a.25.25 0 0 0-.25.25v9a1.5 1.5 0 0 0 1.5 1.5H9.1a.25.25 0 0 0 .246-.212 8.01 8.01 0 0 1 5.722-6.475M8.5 3.75a.25.25 0 0 0 .25.25h5.35a.25.25 0 0 0 .177-.427L11.4.689A1.5 1.5 0 0 0 10.335.25H8.75A.25.25 0 0 0 8.5.5z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 5,
    fill: "#BD565F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2BEBE",
    d: "M17.25 10.75a6.5 6.5 0 1 0 6.5 6.5 6.51 6.51 0 0 0-6.5-6.5m-2.65 8.091 1.414-1.414a.25.25 0 0 0 0-.354L14.6 15.659a.75.75 0 0 1 1.06-1.059l1.414 1.414a.25.25 0 0 0 .353 0l1.414-1.414a.75.75 0 0 1 1.061 1.06l-1.414 1.414a.25.25 0 0 0 0 .354l1.412 1.413a.75.75 0 1 1-1.061 1.06l-1.414-1.414a.25.25 0 0 0-.353 0L15.66 19.9a.75.75 0 1 1-1.061-1.06z"
  })));
};
export default SvgShipmentNotPossible;